import { c as _c } from "react/compiler-runtime";
import { TOptions } from 'i18next';
import { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat';
import { Trans } from 'next-i18next';
import * as React from 'react';
import { TLocoType } from 'shared/hooks/use-loco-translation';
interface TransLocoBaseProps {
  i18nKey: string;
  components?: readonly React.ReactElement<any>[] | {
    readonly [tagName: string]: React.ReactElement<any>;
  };
  values?: any;
}
interface TransLocoWithT extends TransLocoBaseProps {
  t: TLocoType;
  tICU?: never;
}
interface TransLocoWithTICU extends TransLocoBaseProps {
  t?: never;
  tICU: (assetKey: string, values: Record<string, PrimitiveType | FormatXMLElementFn<string>>, options?: TOptions) => any;
}
export type TransLocoProps = TransLocoWithT | TransLocoWithTICU;
const TransLoco = t0 => {
  const $ = _c(9);
  const {
    t,
    tICU,
    i18nKey,
    components,
    values
  } = t0;
  const translationFunction = tICU || t;
  let t1;
  if ($[0] !== i18nKey || $[1] !== translationFunction || $[2] !== values) {
    t1 = () => translationFunction(i18nKey, values);
    $[0] = i18nKey;
    $[1] = translationFunction;
    $[2] = values;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== components || $[5] !== i18nKey || $[6] !== t1 || $[7] !== values) {
    t2 = <Trans t={t1} i18nKey={i18nKey} components={components} values={values} />;
    $[4] = components;
    $[5] = i18nKey;
    $[6] = t1;
    $[7] = values;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default TransLoco;